export default __webpack_public_path__ + "static/media/expl-dissect_14_DE.2d7969f7.png";